import "../../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { getCurrentInstance as w, computed as h } from "../../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as v, reactive as m } from "../../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
function V() {
  const l = w();
  if (!l)
    throw new Error("useFormMixins must be used within a Vue component");
  const f = v([]), u = m({}), c = m({}), E = l.props, g = h(() => Object.fromEntries(
    (f.value || []).map(({ code: o, values: n, allowEdit: e, required: t }) => [
      o,
      {
        // 过滤无效值
        values: n.filter(
          ({ valueCode: r, value: s, default: a }) => r || s || !a
        ),
        props: { disabled: !e },
        required: t,
        defaultValue: (n.find(({ default: r }) => r) || {}).value || ""
      }
    ])
  ));
  return {
    formSelect: f,
    formData: u,
    rules: c,
    propToValueMap: g,
    allowEditFun: (o, n) => {
      const e = o.find((t) => t.code === n);
      return e ? !!e.allowEdit : !1;
    },
    setDefault: (o, n) => {
      o.forEach((e) => {
        var r, s, a, d, p;
        const t = n.find((i) => i.code === e.name);
        u[e.name] = (p = (d = (r = E.options) == null ? void 0 : r[e.name]) != null ? d : (a = (s = t == null ? void 0 : t.values) == null ? void 0 : s.find((i) => i.default)) == null ? void 0 : a.value) != null ? p : u[e.name];
      });
    },
    setRequired: (o, n) => {
      o.forEach((e) => {
        const t = n.find((r) => r.code === e.name);
        t && t.required === 1 ? c[e.name] = [
          {
            required: !0,
            message: e.message,
            trigger: ["blur", "change"],
            type: e.type || "string"
          }
        ] : c[e.name] = [];
      });
    }
  };
}
export {
  V as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/components/formMixin.js
// module id = 207
// module chunks = 67